import React from 'react';
import CustomerProfile from './customerProfile';
import Invoice from './invoice';
import UserProfile from './userProfile';
import ReactDOM from "react-dom";
//import { AcroFormRadioButton } from 'jspdf';
//import Invoice from './invoice';

export default class ItemAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            error: null,
            isLoaded: false,
            isSubmitting: false,
            item: null
        };
    }

    itemCheck() {
        var userID = UserProfile.getUserID();
        var uCompanyID = UserProfile.getCompanyID();
        var name = document.getElementById("name").value;
        var amount = document.getElementById("amount").value;
        var unit = document.getElementById("unit").value;
        var price = document.getElementById("price").value;
        var cod = document.getElementById("cod").value;
        var num = document.getElementById("num").value;
        var tax = 1;
        if ((UserProfile.getUserVat() > 0)) {
            var sel = document.getElementById("tax");
            tax = sel.options[sel.selectedIndex].value;
        }
        if (name === '' || amount === '' || unit === '' || price === '' || isNaN(price) === true) {
            if (isNaN(price) === true) {
                new Invoice().itemRecordingPriceError();
            } else {
                new Invoice().itemRecordingError();
            }
        } else {
            var data = {
                event: 'i-write',
                userID: userID,
                uCompanyID: uCompanyID,
                name: name,
                amount: amount,
                unit: unit,
                price: price,
                cod: cod,
                num: num,
                tax: tax
            };
            var url = UserProfile.getURL() + '/invoice/ajax.php';
            fetch(url, {
                method: "POST",
                body: new URLSearchParams(data),
                headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoaded: true,
                            item: result
                        });
                        if (CustomerProfile.getCompanyID() !== 0 || CustomerProfile.getCompanyID() !== '') {
                            this.itemsGet();
                        } else {
                            this.cliensGet();
                        }
                    },
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
    }

    itemDelete(itemID) {
        var companyID = UserProfile.getCompanyID();
        var data = { event: 'i-del', del: itemID };
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                return res.json();
            })
            .then(
                (result) => {
                    this.isLoaded = true;
                    this.itemsGet(companyID);
                },
                (error) => {
                    this.isLoaded = true;
                    this.error = error;
                }
            )
    }

    itemsGet(companyID) {
        new Invoice().itemsGet(companyID);
    }

    cliensGet() {
        new Invoice().cliensGet();
    }

    selectVat(vat) {
        var vatSelect = '';
        if (vat > 0) {
            vatSelect = <div className='vat'>ÁFA:<select id='tax'>
                <option value='1.27'>27</option>
                <option value='1.18'>18</option>
                <option value='1.05'>5</option>
                <option value='1'>TAM</option>
            </select></div>;
        }
        return vatSelect;
    }

    itemAmountData() {
        var data = { event: 'amount-search' };
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                return res.json();
            })
            .then(
                (result) => {
                    this.isLoaded = true;
                    this.itemAmountShow(result);
                },
                (error) => {
                    this.isLoaded = true;
                    this.error = error;
                }
            )
    }

    itemAmountShow(amountData) {
        const amountList = amountData.map((amount) => <li onClick={() => this.amountAdd(amount.name)} key={amount.unitID}><label>{amount.name}</label></li>);
        if (document.getElementById('search').style.display === 'none') {
            document.getElementById('search').style.display = 'block';
            ReactDOM.render(
                <ul>{amountList}</ul>, document.getElementById('search')
            );
        } else {
            document.getElementById('search').style.display = 'none';
        }
    }

    amountAdd(amount) {
        document.getElementById('search').style.display = 'none';
        document.getElementById('amount').value = amount;
    }

    render() {
        return (
            <div>
                <h1>Számla tétel rögzítése</h1>
                <b>{this.props.name}</b>
                {this.state.value}
                <div className='row'>
                    <input id='name' type='text' placeholder=' Tétel neve' />
                </div>
                <div className='row'>
                    <input id='amount' onClick={() => this.itemAmountData()} type='text' placeholder=' Tétel egysége' />
                </div>
                <div id='search'></div>
                <div className='row'>
                    <input id='unit' type='text' placeholder=' Tétel mennyisége' />
                </div>
                <div className='row'>
                    <input id='price' type='text' placeholder=' Tétel ára' />
                </div>
                <div className='row'>
                    <input id='cod' type='text' placeholder=' Szolgáltatás kódja' />
                </div>
                <div className='row'>
                    <input id='num' type='text' placeholder=' Szolgáltatás száma' />
                </div>
                {this.selectVat(UserProfile.getUserVat())}
                <div>
                    <button className='push' onClick={() => this.itemCheck()}>
                        {this.props.value}
                    </button>
                </div>
            </div>
        );
    }
}